import classes from './YellowDivider.module.css'
import React from 'react'

const SmallYellowDivider = ({ alignLeft }) => {
  return <div className={alignLeft ? classes.leftYellowDivider : classes.smallYellowDivider} />;
};

export default SmallYellowDivider;
